import StoredLayout from '../../layouts/StoredLayout'
import IconWidgets from './IconWidgets'
export default StoredLayout(IconWidgets)
